import React,{useEffect, useState} from "react";
import BackgroundSecond from '../images/Background-second.svg';
// import Camera from '../images/Camera.svg';
// import CameraOff from '../images/Camera-off.svg';
// import rotateblue from '../images/rotateblue.svg';
// import cameraClick from '../images/camera-Click.svg';
import arrow from '../images/Right-arrow.svg';
import SkinBar from "./SkinBar";
import SkinCloseBar from "./SkinCloseBar";
import BackgroundBar from "./BackgroundBar";
import BackgroundSecondBlue from '../images/Background-blue.svg';
import Background from '../images/Background.svg';
import BackgroundThird from '../images/Background-third.svg';
import BackgroundBlue from '../images/Background-second-blue.svg';
import BackgroundThirdBlue from '../images/Background-third-blue.svg';
import Skin from '../images/Texture.svg';
import SkinSecond from '../images/Skin-second.svg';
import SkinSecondBlue from '../images/Skin-second-blue.svg';
import SkinThirdBlue from '../images/Skin-third-blue.svg';
import SkinThird from '../images/Skin-third.svg';
import SkinBlue from '../images/Onclick-Skin.svg';
import CameraBar from "./CameraBar";
import ReactGA from "react-ga4";

// import TimelineBar from "./TimelineBar";
const preloadSrcList = [
    arrow,
    Background,
    BackgroundBlue,
    BackgroundSecondBlue,
    BackgroundSecond,
    BackgroundThird,
    BackgroundThirdBlue,
    Skin,
    SkinBlue,
    SkinSecond,
    SkinSecondBlue,
    SkinThird,
    SkinThirdBlue
  ]

// function preloadImage (src: string) {
//     return new Promise((resolve, reject) => {
//       const img = new Image()
//       img.onload = function() {
//         resolve(img)
//       }
//       img.onerror = img.onabort = function() {
//         reject(src)
//       }
//       img.src = src
//     })
// }

export default function PortraitControlBar(props){

    const [skin, setSkin] = useState(true)
    const [skinIds, setSkinIds] = useState([0,1,2])
    const [backgroundIds, setBackgroundIds] = useState([0,1,2])

    const [clickMode, setClickMode ] = useState(false)


  
    useEffect(() => {
        preloadSrcList.forEach((image) => {
        new Image().src = image
        });
    }, []);

    function toggleSkin(){
        setSkin(false)
        
        setTimeout(() => {
            setSkin(true)
        }, 20000);
    }

    function toggleCloseSkin(){
        setSkin(true) 
    }



    const onMouseDownHandler = () => {
        setClickMode(true);
        // console.log("onMouseDown Event!");
    };

    const onMouseUpHandler = () => {
        setClickMode(false);
        // console.log("onMouseUp Event!");
    };

    const onMouseLeaveHandler = () => {
        setClickMode(false);
        // console.log("onMouseUp Event!");
    };

    const onSkinClicked = (numSkin) => {
        if(numSkin >= 0 && numSkin < 3) setSkinIds([numSkin,(numSkin + 1 )%3,(numSkin + 2 )%3 ]);
        props.onChangeShader(numSkin)
    };


    
    const onBackgroundClicked = (numBackground) => {
        if(numBackground >= 0 && numBackground < 3) setBackgroundIds([numBackground,(numBackground + 1 )%3,(numBackground + 2 )%3 ]);
        props.changeBackGroundClicked(numBackground)
        // props.onChangeShader(numBackground)
        // console.log(([numBackground,(numBackground + 1 )%3,(numBackground + 2 )%3 ]));
    };

    function getSkin(num){
        if(num == 0){
            return Skin;
        }
        if(num == 1){
            return SkinSecond;
        }
        if(num == 2){
            return SkinThird;
        }
    }
    function getSkinBlue(num){
        if(num == 0){
            return SkinBlue;
        }
        if(num == 1){
            return SkinSecondBlue;
        }
        if(num == 2){
            return SkinThirdBlue;
        }
    }

    function getBackground(num){
        if(num == 0){
            return Background;
        }
        if(num == 1){
            return BackgroundSecond;
        }
        if(num == 2){
            return BackgroundThird;
        }
    }

    function getBackgroundBlue(num){
        if(num == 0){
            return BackgroundBlue;
        }
        if(num == 1){
            return BackgroundSecondBlue;
        }
        if(num == 2){
            return BackgroundThirdBlue;
        }
    }


    return(
        <div>
                {(skin)? 
                
                    (  
                        <div onClick={() => {
                                toggleSkin()
                                ReactGA.event({category: 'Engagement',action: "ui_texture_menu",value: 1})
                            }}>
                            <div className="arrow-skin-item">
                                <img src={arrow} alt="Logo" className="arrow--icon" />
                            </div>
                            <SkinCloseBar skinIds={skinIds} getSkinBlue={getSkinBlue} getSkin={getSkin}/>
                        </div>
                    )
                
                :

                    (
                        <div>
                            <div className="skin-item" onClick={() => {
                                toggleCloseSkin();
                                onSkinClicked(skinIds[0])
                                // toggleSkin();
                            }
                        }>
                            <img src={(clickMode == true)? getSkinBlue(skinIds[0]) :getSkin(skinIds[0])} 
                                onClick={ReactGA.event({category: 'Engagement',action: "ui_texture_default",value: 1})}
                                onMouseDown={onMouseDownHandler}
                                onMouseUp={onMouseUpHandler}
                                onMouseLeave={onMouseLeaveHandler}
                                onTouchEnd={onMouseLeaveHandler}
                                alt="Logo" 
                                className="skin--icon"
                            />
                            </div>
                            <SkinBar skinIds={skinIds} getSkin={getSkin} getSkinBlue={getSkinBlue} onSkinClicked={onSkinClicked}/>
                        </div>
                    )
                }
         
                {/* {(background)? 
                
                (  
                    <div onClick={() => toggleBackground()}>
                        <div className="arrow-background-item">
                            <img src={arrow} alt="Logo" className="arrow--icon" />
                        </div>
                        <div className="background-item" >
                            <img src={Background} alt="Logo" className="background--icon" />
                        </div>
                    </div>
                )
            
            :

                (
                    <div>
                      
                            <BackgroundBar/>
                    </div>
                )
            } */}

            <BackgroundBar  backgroundIds={backgroundIds} getBackground={getBackground} getBackgroundBlue={getBackgroundBlue} onBackgroundClicked={onBackgroundClicked}/>


           <CameraBar onAutoRotateClicked={props.onAutoRotateClicked}/>
        </div>
    )
}